import includes from 'lodash/includes';
import Cookie from 'js-cookie';

export default class CookieAdapter {
  get(key) {
    let cookie = Cookie.getJSON(key);

    // temporary fix for transitioning sessionIds to an array
    if (includes(key, 'gladlyChatSession-')) {
      if (cookie && cookie.sessionId) {
        return { sessionIds: [cookie.sessionId] };
      }
    }

    return cookie;
  }
  set(key, value, options) {
    return Cookie.set(key, value, options);
  }
  remove(key) {
    return Cookie.remove(key);
  }
}
